import { all } from 'redux-saga/effects';
import { watchAllAuthenticationActions } from './authenticationSaga';
import { watchAllCompanyActions } from './companySaga';
import { watchAllCustomerActions } from './customerSaga';
import { watchAllGeneralActions } from './generalSaga';
import { watchAllOrderActions } from './orderSaga';
import { watchAllProductActions } from './productSaga';
import { watchAllStoreActions } from './storeSaga';

export default function* rootSaga() {
  yield all([
    watchAllAuthenticationActions(),
    watchAllOrderActions(),
    watchAllCompanyActions(),
    watchAllProductActions(),
    watchAllCustomerActions(),
    watchAllStoreActions(),
    watchAllGeneralActions()
  ])
}